export const CheckIcon = ({
  className = 'w-4 h-4',
  fill = 'currentColor',
}: {
  className?: string;
  fill?: string;
}) => (
  <svg
    width="12"
    height="9"
    viewBox="0 0 12 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M3.81353 7.10067L0.968732 4.30201L0 5.24832L3.81353 9L12 0.946309L11.0381 0L3.81353 7.10067Z"
      fill={fill}
    />
  </svg>
);
